<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <app-api-table
      [name]="name"
      [endpoint]="endpoint()"
      [hasIndexCol]="true"
      [hasChartView]="false"
      [onRowClick]="openEvaluationDetails"
      [skipFilters]="true"
    ></app-api-table>
  }
</app-tab-layout>

<app-modal
  [title]="selectedEvaluationTitle()"
  size="xxl"
  [opened]="isDetailsModalOpen()"
  (closeTrigger)="onModalClose()"
>
  <div class="evaluation-details-modal">
    @if (selectedEvaluationId()) {
      <app-api-table
        [name]="'evaluation-details'"
        [endpoint]="
          '/evaluations/tables/user-evaluation-details/' +
          userId() +
          '/' +
          selectedEvaluationId()
        "
        [defaultSort]="{ 'Category': 'desc' }"
        [hasIndexCol]="true"
        [hasChartView]="false"
        [skipFilters]="true"
      ></app-api-table>
    }
  </div>
</app-modal>